import { useMemo } from 'react';
import { useUser } from '../stores';
import { createApiClient } from '../services/api/client';
import { UserService } from '../services/api/user';
import { ProfileService } from '../services/api/profile';
import { AccountService } from '../services/api/account';
import { ContentService } from '../services/api/content';
import { LabService } from '../services/api/lab';
import { DomainService } from '../services/api/domain';
import { ModelService } from '../services/api/model';
import { CtdEnsembleService } from '../services/api/ctdEnsemble';
import { SubscriptionService } from '../services/api/subscription';
import { PerformanceService } from '../services/api/performance';
import { EPickListService } from '../services/api/ePickList';
import { SupportService } from '../services/api/support';
// Create a singleton instance for the API client
let apiClientInstance: ReturnType<typeof createApiClient> | null = null;

/** Type representing all API services returned by useApi() */
export type ApiServices = ReturnType<typeof useApi>;

export const useApi = () => {
  const { getValidToken } = useUser();
  
  // Create or reuse the API client instance
  if (!apiClientInstance) {
    apiClientInstance = createApiClient(getValidToken);
  }
  
  // Memoize the services
  const services = useMemo(() => ({
    user: UserService(apiClientInstance!.identityApi),
    profile: ProfileService(apiClientInstance!.identityApi),
    account: AccountService(apiClientInstance!.identityApi),
    subscription: SubscriptionService(apiClientInstance!.identityApi),
    content: ContentService(apiClientInstance!.contentApi),
    lab: LabService(apiClientInstance!.modelApi),
    domain: DomainService(apiClientInstance!.domainApi),
    model: ModelService(apiClientInstance!.modelApi),
    ctdEnsemble: CtdEnsembleService(apiClientInstance!.modelApi),
    performance: PerformanceService(apiClientInstance!.modelApi),
    ePickList: EPickListService(apiClientInstance!.modelApi),
    support: SupportService(apiClientInstance!.identityApi)
  }), []); // Empty deps since apiClientInstance is singleton

  return services;
}; 